export const GET_DOCUMENT_REQUEST = 'user.document.GET_CONTRACT_INVOICE_REQUEST'
export const GET_DOCUMENT_SUCCESS = 'user.document.GET_CONTRACT_INVOICE_SUCCESS'
export const GET_DOCUMENT_FAILURE = 'user.document.GET_CONTRACT_INVOICE_FAILURE'
